import React from "react";

/**
 * ReadOnlyActions — for statuses with no admin actions
 * Used by: Rejected, Completed, Paused, Closed, Draft, Cancelled, Deleted
 */
const ReadOnlyActions = () => {
  return null;
};

export default ReadOnlyActions;
